// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_1DDwYTkbvNoVwBDs8ZptVg","load3":"_3wkyiZSYyg2Di5C16AAkyy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 130
// module chunks = 0